import { usePackageCarsAvailabilityFilters } from "../../../hooks";
import type { PackageCarsAvailabilityPageProps } from "../types";
import { usePackageCarsAvailabilityPageFetch } from "./usePackageCarsAvailabilityPageFetch";

export const usePackageCarsAvailabilityPage = (
  props: PackageCarsAvailabilityPageProps
) => {
  usePackageCarsAvailabilityPageFetch(props);

  // Use package-specific filters hook that handles incremental pricing
  const { context } = usePackageCarsAvailabilityFilters();

  const {
    data: { data: carsList },
    isLoading,
    isError,
  } = context.filteredCars;

  const hasFilters = context.hasFilters;

  return {
    context: { isLoading, isError, carsList, hasFilters },
    handlers: {
      onErrorReload: () => {
        console.log("reloading cars");
      },
    },
  };
};
